'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _reactTappable = require('react-tappable');

var _reactTappable2 = _interopRequireDefault(_reactTappable);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _helper = require('../../helpers/helper');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _scrapper = require('../../redux/modules/scrapper');

var _outfeat = require('../../redux/modules/outfeat');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    scrapper: state.scrapper,
    outfeat: state.outfeat,
    user: state.auth.user,
    editedItems: state.editedItems,
    routing: state.routing,
    instagramPics: state.instagram.posts ? state.instagram.posts.map(function (p) {
      return { id: p.id, url: p.images.standard_resolution.url };
    }) : []
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Home).call(this, props));

    var translateContainer = false;
    var animateTranslate = true;
    if (_this2.props.location.pathname === "create" || _this2.props.location.pathname === "/create" || _this2.props.outfeat.current.images.length > 0) {
      translateContainer = true;
      animateTranslate = false;
    }
    (0, _helper.bindAll)(_this2);

    _this2.state = {
      isModalOpen: false,
      uploading: false,
      translateContainer: translateContainer,
      animateTranslate: animateTranslate,
      scrapperList: {},
      progress: 0,
      currentUrl: null,
      user: _this2.props.user,
      outfeat: _this2.props.outfeat.current
    };
    return _this2;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var scrapper = newProps.scrapper;
      var outfeat = newProps.outfeat;
      var location = newProps.location;
      var user = newProps.user;
      var scrapperList = this.state.scrapperList;

      if (scrapper !== scrapperList && scrapper.isLoading === false) {
        this.setState({ scrapperList: scrapper });
        this._addLink(scrapper, this.state.currentUrl);
      }
      if (outfeat.current !== this.state.outfeat) {
        this.setState({ outfeat: outfeat.current });
        if (outfeat.current.images.length > 0) {
          this.setState({ translateContainer: true });
        }
      }
      if (location.pathname === "create" || location.pathname === "/create") {
        this.setState({ translateContainer: true, animateTranslate: false });
      }
      if (user && user.outfeats !== this.state.user.outfeats && user.outfeats.length > 0) {
        var id = user.outfeats[user.outfeats.length - 1];
        this.setState({ user: user });
        this.context.router.push('/' + id + '?created=true');
      }
    }
  }, {
    key: '_addLink',
    value: function _addLink(scrapper, url) {
      var currentUrl = this.state.currentUrl;

      if (scrapper.urls[currentUrl]) {
        var newItem = scrapper.urls[this.state.currentUrl];
        newItem.activeImg = 0;
        var id = Math.random().toString(36).substring(7);
        newItem.id = id;
        this.props.dispatch((0, _outfeat.addItem)(newItem));
      }
    }
  }, {
    key: '_addEmptyItem',
    value: function _addEmptyItem() {
      var id = Math.random().toString(36).substring(7);
      var newItem = {
        activeImg: 0,
        description: "Manually added item",
        id: id,
        images: [],
        link: '',
        price: 'Edit price',
        productId: '',
        store_url: 'Brand URL',
        title: 'Edit item name'
      };
      this.props.dispatch((0, _outfeat.addItem)(newItem));
    }
  }, {
    key: '_create',
    value: function _create() {
      if (this.state.outfeat.images.length > 0 && this.state.outfeat.items.length > 0) {
        this.props.dispatch((0, _outfeat.create)(this.state.outfeat));
      }
    }
  }, {
    key: '_handleCreate',
    value: function _handleCreate() {
      if (this.props.user.username) {
        this._create();
      } else {
        this.setState({ isModalOpen: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this3 = this,
          _classNames2;

      var scrapper = this.props.scrapper;
      var outfeat = this.state.outfeat;

      var redirect_uri = _config2.default.instagramRedirectURL;
      var pathname = this.props.location.pathname;
      var info = scrapper.urls[this.state.currentUrl] || {};
      var styles = require('./Home.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.container, (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.isTranslated, this.state.translateContainer), (0, _defineProperty3.default)(_classNames, styles.isAnimated, this.state.animateTranslate), _classNames)) },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Outfeats | The easiest way to create and share your outfits. ' }),
        _react2.default.createElement(
          'section',
          { className: (0, _classnames2.default)(styles.section, styles.intro, styles.centered) },
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'h1',
              null,
              'Outfeats.'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'The easiest way to create and share your outfits.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Beautiful & no account required. ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: 'discover' },
                'See examples.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(styles.buttons, 'display-small') },
              _react2.default.createElement(
                _reactTappable2.default,
                { onTap: function onTap() {
                    return _this3.setState({ translateContainer: true });
                  } },
                _react2.default.createElement(
                  'button',
                  { className: 'btn btn-gold' },
                  'Start creating'
                )
              ),
              _react2.default.createElement(
                _reactTappable2.default,
                { onTap: function onTap() {
                    return _this3.context.history.push('discover');
                  } },
                _react2.default.createElement(
                  'button',
                  { className: 'btn btn-grey btn-outline' },
                  'Discover'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { className: (0, _classnames2.default)(styles.section, styles.dropzone, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, styles.centered, !this.state.translateContainer), (0, _defineProperty3.default)(_classNames2, styles.translated, this.state.translateContainer), _classNames2)) },
          _react2.default.createElement(_components.DropZone, {
            pics: outfeat.images,
            instagramPics: this.props.instagramPics,
            onDelete: function onDelete(img) {
              return _this3.props.dispatch((0, _outfeat.deleteImage)(img));
            },
            onComplete: function onComplete(img) {
              return _this3.props.dispatch((0, _outfeat.addImage)(img));
            } })
        ),
        _react2.default.createElement(
          'section',
          { className: (0, _classnames2.default)(styles.section, styles.scrapform) },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.ScrapForm, {
              isLoading: scrapper.isLoading,
              isError: scrapper.error,
              handleManual: function handleManual() {
                return _this3._addEmptyItem();
              },
              onSubmit: function onSubmit(value) {
                // @TODO replace by proper url checking
                if (value.url && value.url.length) {
                  (function () {
                    var _this = _this3;
                    _this3.setState({
                      isLoadingScrapper: true,
                      currentUrl: value.url
                    }, function () {
                      _this.props.dispatch((0, _scrapper.scrape)(value.url));
                    });
                  })();
                }
              } })
          ),
          _react2.default.createElement(_components.ItemList, {
            items: outfeat.items,
            editedItems: this.props.editedItems,
            onEdit: function onEdit(id, item) {
              return _this3.props.dispatch((0, _outfeat.editItem)(id, item));
            },
            onDelete: function onDelete(id) {
              return _this3.props.dispatch((0, _outfeat.deleteItem)(id));
            },
            mode: 'edit' }),
          _react2.default.createElement(
            'button',
            { onClick: this._handleCreate, disabled: this.state.outfeat.images.length === 0 || this.state.outfeat.items.length === 0, className: (0, _classnames2.default)(styles.createBtn, 'hide-small') },
            ' CREATE '
          )
        ),
        _react2.default.createElement(
          'button',
          { onClick: this._handleCreate, disabled: this.state.outfeat.images.length === 0 || this.state.outfeat.items.length === 0, className: (0, _classnames2.default)(styles.createBtn, styles.createBtnMobile, 'display-small', (0, _defineProperty3.default)({}, styles.isDisplayed, this.state.translateContainer)) },
          ' CREATE '
        ),
        this.state.isModalOpen && _react2.default.createElement(
          _components.Modal,
          { onClose: function onClose() {
              return _this3.setState({ isModalOpen: false });
            } },
          _react2.default.createElement(
            'div',
            { className: styles.modalContent },
            _react2.default.createElement(
              'h2',
              null,
              'One last thing.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You\'re about to post an ',
              _react2.default.createElement(
                'b',
                null,
                'anonymous outfeat'
              ),
              ', it won\'t be associated to any account.'
            ),
            _react2.default.createElement(
              'button',
              { className: styles.buttonOk, onClick: this._create },
              'Post as anonymous'
            ),
            _react2.default.createElement(
              'a',
              { href: 'https://www.instagram.com/oauth/authorize/?client_id=432f7984e8374318b15c9687588f4f74&redirect_uri=' + redirect_uri + '?from=' + pathname + '&response_type=code' },
              _react2.default.createElement(
                'small',
                null,
                'or'
              ),
              ' Connect with Instagram'
            )
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  scrapper: _react.PropTypes.object,
  outfeat: _react.PropTypes.object
}, _class2.contextTypes = {
  location: _react2.default.PropTypes.object,
  history: _react2.default.PropTypes.object,
  router: _react2.default.PropTypes.object,
  routing: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = Home;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Home/Home.js
 ** module id = 1109
 ** module chunks = 0
 **/